import React from "react";

import IconButton from "@replo/design-system/components/button/IconButton";
import {
  Card,
  CardContent,
} from "@replo/design-system/components/shadcn/core/card";
import { CircleX } from "lucide-react";

const ErrorCard = ({
  title,
  subtitle,
}: {
  title: string;
  subtitle: string;
}) => {
  return (
    <Card className="max-w-full p-0 mb-3 mr-3">
      <CardContent className="flex flex-col items-start gap-2 p-4">
        <div className="flex flex-row gap-3 items-start">
          <IconButton
            variant="secondary"
            UNSAFE_className="bg-danger-soft border-danger/50"
            icon={<CircleX size={16} className="text-danger" />}
          />
          <div className="flex flex-col gap-1">
            <div className="text-base font-semibold">{title}</div>
            <div className="text-sm text-muted relative">{subtitle}</div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default ErrorCard;
